import { Store } from 'vuex'
import { AxiosError, AxiosInstance } from 'axios'
import { instanceNoAuth } from '@/model/api/apibase'
import { State as StoreState } from '@/store/index'
import API_URL from '@/model/api/apiUrlType'
import { ErrorResponse } from '@/model/api/error/erroResponse'

// レスポンスデータ
type ResponseData = {
  // ユーザー名
  username: string
  // ユーザー表示名
  usernamedisp: string
  // CSRFトークン
  csrftoken: string
}

/**
 * ユーザー認証の関数を返す
 * @param store vuex
 * @returns ユーザー認証の関数
 */
const useUserAuth = (store: Store<StoreState>) => {
  // API通信インスタンス
  const instance: AxiosInstance | undefined = instanceNoAuth(store)

  /**
   * ユーザー認証情報取得処理を実施
   * @returns レスポンスデータ(失敗時はundefined)
   */
  const get = async () => {
    // 戻り値
    let normaldata: ResponseData | undefined
    // 認証後のaxiosインスタンス取得
    const obj = instance
    await obj
      .get<ResponseData>(
        API_URL.USERS.AUTH_GET // URL
      )
      .then((response) => {
        // 更新成功時はレスポンスを返却
        normaldata = response.data
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((_e: AxiosError<ErrorResponse>) => {
        // ここでは異常時は何も返さない
      })
    return {
      normaldata,
    }
  }
  return {
    instance,
    get,
  }
}

export {
  useUserAuth, //
  ResponseData,
}
